export default {
  wrong: 'Incorreto',
  right: 'Correto',
  nonexistent: 'Inexistente',
  inconsistent: 'Incompatível',
  empty: 'Vázio!',
};
